Storage = require('common/lib/storage').default
module.exports = Storage



// WEBPACK FOOTER //
// ./app/scripts/lib/storage.coffee